module.exports = __webpack_public_path__ + "static/media/81824.5119f04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ourStaff/81824.jpg
// module id = 1430
// module chunks = 0